import React, { useEffect, useState } from 'react';
import { ping } from '../utils/apiUtils';

interface ApiStatusCheckProps {
  apiBaseUrl: string | null;
}

/**
 * Componente que verifica a disponibilidade da API e exibe um alerta quando indisponível
 */
const ApiStatusCheck: React.FC<ApiStatusCheckProps> = ({ apiBaseUrl }) => {
  const [apiAvailable, setApiAvailable] = useState<boolean | null>(null);
  
  useEffect(() => {
    const checkApi = async () => {
      // Se apiBaseUrl for null, estamos em modo de desenvolvimento com mock
      if (!apiBaseUrl) {
        setApiAvailable(true); // Considera como disponível pois usamos mock
        return;
      }
      
      const isAvailable = await ping(apiBaseUrl);
      setApiAvailable(isAvailable);
      
      // Se a API estiver indisponível, tenta verificar novamente após 30 segundos
      if (!isAvailable) {
        const timer = setTimeout(() => {
          setApiAvailable(null); // Reseta para disparar nova verificação
        }, 30000);
        
        return () => clearTimeout(timer);
      }
    };
    
    if (apiAvailable === null) {
      checkApi();
    }
  }, [apiBaseUrl, apiAvailable]);
  
  // Não exibe nada se ainda não verificou ou se a API está disponível
  if (apiAvailable === null || apiAvailable === true) {
    return null;
  }
  
  // Exibe um alerta se a API estiver indisponível
  return (
    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
      <h4 className="font-bold text-lg mb-2">Problemas de conexão!</h4>
      <p>
        Não foi possível conectar ao servidor. Algumas funcionalidades podem não estar disponíveis.
        Verifique sua conexão com a internet ou tente novamente mais tarde.
      </p>
    </div>
  );
};

export default ApiStatusCheck;